<template>
  <div class="sdiv dinline-block vtop">
    <div class="est">
      <router-link to="/aedu/notice/index" class="more fr tc9 mt5 mr5">更多+</router-link>
      <span class="tt blue prelative dinline-block prelative pb5 fs20 fbold">通知公告</span>
    </div>
    <div class="cont pl10 pt15">
      <div class="news prelative fs15 tc6 cpointer lh17" v-for="(item,index) in notice" v-if="index < 5" :key="index" :index="index" :item="item" @click="goRoute(item.id)">
        {{item.title}} <span class="fs12">（{{item.release_time}}）</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "list-left",
  props: [
    'notice',
  ],
  methods:{
    goRoute(id){
      let path = `/aedu/notice/detail?id=${id}` 
      let routeData = this.$router.resolve({
          path
      })
      window.open(routeData.href, '_blank')
      //this.$router.push({path:'/aedu/notice/detail',query:{id:id}})
    },
  }
}
</script>

<style scoped>
  .est{border-bottom: 1px solid #ddd;}
  .est .tt{margin-bottom: -1px;}
  .est .blue{border-bottom: 1px solid #1787e0;}
  .eindex-wrap .newsdiv .news:hover{color: #063674;font-weight: bold;}
  .eindex-wrap .newsdiv .news:hover::before{border-color: #063674;}
  .eindex-wrap .newsdiv .news{padding: 5px 0 0 20px;border-left: 1px solid #ddd;height: 70px;}
  .eindex-wrap .newsdiv .news::before{content: '';position: absolute;left: -7px;top: 10px;width: 13px;height: 13px;background: #fff;border: 2px solid #e5e5e5;border-radius: 50%;}
  .eindex-wrap .newsdiv .news:last-child{height: 60px;}
  .eindex-wrap .newsdiv .more:hover{color: #063674;}
</style>



// WEBPACK FOOTER //
// src/components/aedu/index/list-left.vue